/* styles */
import './general/scss/index.scss';

import 'foundation/global-error-handler';
import 'general/js/loaders/scoring-loader';
//import 'general/js/loaders/sw-loader';

/* polyfills */
import 'general/js/polyfills';
import 'general/js/lazysizes';
import 'intersection-observer';
import 'formdata-polyfill';
import 'whatwg-fetch';

/* plugins */
import 'what-input';
import './components/form-custom-select/js/choices.js/public/assets/scripts/choices';

/* shared components */
import 'project/live-helpers';
import 'project/country-flag';

/* components */
import './components/accordion';
import './components/accordion-flexible';
import './components/account';
import './components/account-page';
import './components/account-profile';
import './components/alert-bars';
import './components/anti-forgery-token';
import './components/article-author';
import './components/article-hero';
import './components/article-page';
import './components/article-player-title';
import './components/article-tags';
import './components/ballot-cta';
import './components/banner';
import './components/basket';
import './components/basket-buy-links';
import './components/basket-cleaner';
import './components/basket-icon';
import './components/call-out-panel';
import './components/cards';
import './components/carousel-controls';
import './components/championship-days';
import './components/checkout-page';
import './components/comparison-tool';
import './components/content-type';
import './components/contextual-info-panel';
import './components/contextual-latest-news';
import './components/contextual-link-panel';
import './components/contextual-manager';
import './components/contextual-rolex';
import './components/contextual-rolex-simple';
import './components/contextual-stats';
import './components/cookie-warning';
import './components/countries';
import './components/course';
import './components/custom-analytics';
import './components/custom-event-leaderboard';
import './components/data-capture';
import './components/days-promo';
import './components/dfp-banner';
import './components/document-list';
import './components/dot-mailer-tracker';
import './components/endeavor-player';
import './components/endeavor-player-modal';
import './components/enhanced-stats';
import './components/error-hero';
import './components/extranet-login';
import './components/feature-content';
import './components/featured-list';
import './components/final-leaderboard';
import './components/footer';
import './components/form';
import './components/form-buttons-radio';
import './components/form-checkbox';
import './components/form-checkbox-panel';
import './components/form-custom-select';
import './components/form-date';
import './components/form-field';
import './components/form-file';
import './components/form-page';
import './components/form-phone-input';
import './components/form-popup';
import './components/form-progress';
import './components/form-radio';
import './components/form-round-select';
import './components/form-select';
import './components/full-size-hero-banner';
import './components/general-page-hero';
import './components/generic-content-block';
import './components/gtm-trigger';
import './components/header';
import './components/hero';
import './components/hero-banner-homepage';
import './components/hero-banner-homepage-enhanced';
import './components/hero-banner-qualification';
import './components/highlights-bar';
import './components/highlights-panel';
import './components/hole-flag';
import './components/image';
import './components/image-gallery';
import './components/imga-iframe';
import './components/imga-matchups-game';
import './components/info-panel';
import './components/key-points';
import './components/large-hero';
import './components/leaderboard';
import './components/leaderboard-scoring';
import './components/leaderboard-widget';
import './components/leaderboard-widget-favorite';
import './components/listing';
import './components/live-event-select';
import './components/live-header';
import './components/live-hero';
import './components/live-navigation';
import './components/live-radio';
import './components/live-stats';
import './components/live-submenu';
import './components/live-tabs';
import './components/live-text';
import './components/live-text-widget';
import './components/live-title';
import './components/live-video-widget';
import './components/live-widget';
import './components/live-widgets';
import './components/location-image';
import './components/main-nav';
import './components/make-stories';
import './components/modal';
import './components/modal-spa-trigger';
import './components/modal-trigger-promo-panel';
import './components/multimedia-carousel';
import './components/my-account-url';
import './components/nbc-alert-bars';
import './components/news-feed';
import './components/news-feed-live';
import './components/news-feed-live-selector';
import './components/news-feed-preview';
import './components/next-event-preview';
import './components/notifications';
import './components/one-club-button';
import './components/other-open-venues';
import './components/overlay';
import './components/page-spinner';
import './components/pagination';
import './components/player-bio';
import './components/player-carousel';
import './components/player-feature';
import './components/player-hero';
import './components/player-profiles-stats';
import './components/player-registration-form';
import './components/posts';
import './components/predictive-search';
import './components/previous-opens';
import './components/previous-opens-card';
import './components/promo-panel';
import './components/qual-draw';
import './components/qual-events';
import './components/qual-events-hero';
import './components/qual-leaderboard';
import './components/qualification-notification';
import './components/qualified-golfers';
import './components/qualified-player-card';
import './components/qualified-players-listing';
import './components/qualified-players-preview';
import './components/quote';
import './components/quote-image';
import './components/quote-two-images';
import './components/recaptcha';
import './components/related-news';
import './components/related-page';
import './components/reset-password-url';
import './components/restricted-badge';
import './components/richtext-editor';
import './components/right-header-link-item';
import './components/right-header-links';
import './components/rolex-watch';
import './components/row';
import './components/scores';
import './components/scroll-to-top';
import './components/section';
import './components/sign-posting';
import './components/social-provider';
import './components/social-sharing';
import './components/spa-load';
import './components/spinner';
import './components/sso';
import './components/stats';
import './components/sticky-button-trigger';
import './components/styleguide';
import './components/sub-nav';
import './components/sub-page-nav';
import './components/sublayout';
import './components/tabs';
import './components/tee-times';
import './components/tee-times-widget';
import './components/thank-you';
import './components/the-one-club-hub';
import './components/ticket-builder';
import './components/ticket-option';
import './components/ticket-resale';
import './components/ticket-resale-banner';
import './components/tickets-hospitality-splitter';
import './components/tickets-listing';
import './components/upcoming-events';
import './components/upcoming-opens';
import './components/upcoming-opens-card';
import './components/upcoming-opens-links';
import './components/update-app-modal';
import './components/upsell';
import './components/venue-hero';
import './components/video';
import './components/video-header';
import './components/view-order-url';
import './components/weather-widget';
import './components/weglot';

/* init app */
import app from './general/js/app';

app.init();

/* build svg sprite */
const files = require.context('./general/svg', true, /^\.\/.*\.svg/);
files.keys().forEach(files);

// do not focus sprite in IE
const spriteNode = document.getElementById('__SVG_SPRITE_NODE__');

if (spriteNode) {
    spriteNode.setAttribute('focusable', 'false');
    spriteNode.setAttribute('aria-hidden', 'true');
}
